import {
    NAVIGATE_NEXT,
    NAVIGATE_PREVIOUS,
    navigateToTravelQuote,
    navigateToTravelDetails,
    navigateToTravelNextOfKin,
    navigateToPayment,
} from '../../../actions/travelSs/routing';
import { getActivePageIndex } from '../../../selectors/travelSs/routing';
import { PAGE_INDICES } from '../../../actions/travelSs/types';

export const routingRules = (store, next, action) => {
    if (action.type !== NAVIGATE_NEXT && action.type !== NAVIGATE_PREVIOUS) return next(action);
    const result = next(action);
    const state = store.getState();
    const activePageIndex = getActivePageIndex(state);
    if (action.type === NAVIGATE_NEXT) {
        onNavigateNext(store, state, activePageIndex);
        return result;
    }
    onNavigatePrevious(store, state, activePageIndex);
    return result;
};

const onNavigateNext = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.QUOTE:
            store.dispatch(navigateToTravelDetails());
            break;
        case PAGE_INDICES.NEXT_OF_KIN:
            store.dispatch(navigateToPayment());
            break;
        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToTravelNextOfKin());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};

const onNavigatePrevious = (store, state, activePageIndex) => {
    switch (activePageIndex) {
        case PAGE_INDICES.TRAVEL_DETAILS:
            store.dispatch(navigateToTravelQuote());
            break;
        case PAGE_INDICES.PAYMENT:
            store.dispatch(navigateToTravelNextOfKin());
            break;
        case PAGE_INDICES.NEXT_OF_KIN:
            store.dispatch(navigateToTravelDetails());
            break;
        default:
            store.dispatch(navigateToTravelQuote());
            break;
    }
};
